import { forwardRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { addDays } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'
// import MaskedTextInput from 'react-text-mask'

import * as S from './styles'

const CalendarDatePicker = ({
  periodo,
  rightSide,
  dataInicial,
  setDataInicial,
  dataFinal,
  setDataFinal,
  range,
  calendarModal
}) => {
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedFinalDate, setSelectedFinalDate] = useState('')

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <input
      className="example-custom-input"
      onClick={onClick}
      ref={ref}
      value={value}
      placeholder="De"
      readOnly
    ></input>
  ))

  const CustomInputFinal = forwardRef(({ value, onClick }, ref) => (
    <input
      className="example-custom-input"
      onClick={onClick}
      ref={ref}
      value={value}
      placeholder="Até"
      readOnly
    ></input>
  ))

  return (
    <S.CalendarWrapper rightSide={rightSide}>
      <div className="calendar-start">
        <DatePicker
          selected={selectedDate}
          startDate={dataInicial}
          endDate={dataFinal}
          maxDate={selectedFinalDate}
          value={selectedDate}
          onChange={(date, e) => {
            setSelectedDate(date)
            // const dateFormatted = formatISO(date, { representation: 'date' })
            setDataInicial(date)
          }}
          selectsStart
          dateFormat="dd/MM/yyyy"
          locale={ptBR}
          customInput={<CustomInput />}
          popperPlacement="top"
          withPortal={!!calendarModal}
          isClearable={!!selectedDate}
        ></DatePicker>
      </div>

      <div>
        {!!range && (
          <DatePicker
            selected={selectedFinalDate}
            value={selectedFinalDate}
            onChange={(date, e) => {
              setSelectedFinalDate(date)
              // const dateFormatted = formatISO(date, { representation: 'date' })
              setDataFinal(date)
            }}
            selectsEnd
            startDate={selectedDate}
            endDate={dataFinal}
            minDate={selectedDate}
            // minDate={addDays(selectedDate, 1)}
            dateFormat="dd/MM/yyyy"
            locale={ptBR}
            customInput={<CustomInputFinal />}
            popperPlacement="top"
            withPortal={!!calendarModal}
            isClearable={!!selectedFinalDate}
          ></DatePicker>
        )}
      </div>
    </S.CalendarWrapper>
  )
}

export default CalendarDatePicker
